/*=========================================================================================
  File Name: moduleCategoryActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	save({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/optimization_group", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	update({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put(`/optimization_group/${payload.id}`, payload.items)
				.then((response) => {
					commit("UPDATE_OPTIMIZATION_GROUP", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/optimization_group/${id}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findAll({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/optimization_group")
				.then((res) => {
					commit("SET_OPTIMIZATION_GROUP", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	deleteById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/optimization_group/${id}`)
				.then((response) => {
					commit("REMOVE_OPTIMIZATION_GROUP", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	optimizationGroupFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				fields: data.fields || [],
				id: data.id || [],
				name: data.name || [],
				description: data.description || [],
				total_optimization: data.total_optimization || [],
				total_created: data.total_created || [],
				total_processing: data.total_processing || [],
				total_finalized: data.total_finalized || [],
				total_error: data.total_error || [],
				match_filter: data.match_filter,
				order_by: data.order_by || ["id"],
				sort: data.sort || "asc",
			};
			Api.post("/optimization_group/filter", payload)
				.then((res) => {
					commit("SET_OPTIMIZATION_GROUP", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
